export { default as StrategyCenterHeader } from './StrategyCenterHeader';
